<template>
  <div>
    <div class="container-contact100 pt-10">
      <div class="wrap-contact100">
        <!-- contact form -->
        <form class="contact100-form validate-form">
          <div
            class="alert alert-danger"
            role="alert"
            id="alert"
            v-show="alert"
          >
            <ul>
              <li v-for="err in errors" :key="err">
                {{ err[0] }}
              </li>
            </ul>
          </div>
          <span class="contact100-form-title">
            ثبت نام تامین کنندگان
          </span>
          <label class="label-input100" for="email"
            >نام فروشگاه را وارد کنید</label
          >
          <div class="wrap-input100 validate-input" data-validate="">
            <input
              id="name"
              class="input100"
              type="text"
              v-model="brand"
              placeholder="نام فروشگاه"
            />
            <span class="focus-input100"></span>
          </div>
          <label class="label-input100" for="first-name"
            >نام نماینده را وارد کنید</label
          >
          <div
            class="wrap-input100 rs1-wrap-input100 validate-input"
            data-validate="نام"
          >
            <input
              id="first-name"
              class="input100"
              type="text"
              v-model="agent_firstname"
              placeholder="نام"
            />
            <span class="focus-input100"></span>
          </div>
          <div
            class="wrap-input100 rs2-wrap-input100 validate-input"
            data-validate="نام خانوادگی"
          >
            <input
              class="input100"
              type="text"
              v-model="agent_lastname"
              placeholder="نام خانوادگی"
            />
            <span class="focus-input100"></span>
          </div>
          <label class="label-input100" for="email"
            >شماره تلفن فروشگاه را وارد کنید
          </label>
          <div class="wrap-input100 validate-input" data-validate="">
            <input
              id="phone_number"
              class="input100"
              type="number"
              v-model="phone_number"
              placeholder="Eg. 02112345678"
            />
            <span class="focus-input100"></span>
          </div>
          <label class="label-input100" for="phone"
            >تلفن همراه نماینده را وارد کنید</label
          >
          <div class="wrap-input100">
            <input
              id="phone"
              class="input100"
              type="text"
              v-model="agent_mobile_number"
              placeholder="Eg. 0912123457"
            />
            <span class="focus-input100"></span>
          </div>
          <label class="label-input100" for="message"
            >توضیحات محصولات و برند ها
          </label>
          <div
            class="wrap-input100 validate-input"
            data-validate="نوشتن پیام الزامی است"
          >
            <textarea
              id="message"
              class="input100"
              v-model="description"
              placeholder="توضیحاتی در مورد محصولات خود و برندهای ایرانی که با آن ها کار می کنید برای ما بنویسید"
            ></textarea>
            <span class="focus-input100"></span>
          </div>
          <label class="label-input100" for="message"
            >آدرس فروشگاه را وارد کنید
          </label>
          <div
            class="wrap-input100 validate-input"
            data-validate="نوشتن پیام الزامی است"
          >
            <textarea
              id="address"
              class="input100"
              v-model="address"
              placeholder="آدرس فروشگاه "
            ></textarea>
            <span class="focus-input100"></span>
          </div>
          <div class="container-contact100-form-btn">
            <button
              class="contact100-form-btn"
              @click.prevent="supplierRegister()"
            >
              ثبت نام
            </button>
          </div>
        </form>
        <!-- contact info -->
        <div
          class="contact100-more flex-col-c-m"
          style="background-image: url('/assets/img/bg-01.jpg');"
        >
          <div class="d-flex size1 pb-2 pt-10 mt-10">
            <div class="txt1">
              <!-- <font-awesome-icon icon="map-marker-alt" /> &nbsp; -->
              <i class="fas fa-map-marker-alt"></i>
            </div>
            <div class="flex-col size2 pl-1">
              <span class="txt1 p-b-20">
                {{ $t("aboutus.address") }}
              </span>
              <span class="txt2 pl-1">
                {{ $t("aboutus.addressDes") }}
              </span>
            </div>
          </div>
          <div class="d-flex size1 pb-2">
            <div class="txt1">
              <!-- <span class="fa fa-phone"></span>&nbsp; -->
              <i class="fas fa-phone"></i>
            </div>
            <div class="size2 pl-1">
              <span class="txt1">
                {{ $t("aboutus.telephone") }}
              </span>
              <span class="txt3 pl-1">
                {{ $t("aboutus.phoneNumber") }}
              </span>
            </div>
          </div>
          <div class="d-flex size1 pb-2">
            <div class="txt1 ">
              <!-- <span class="fa fa-envelope"></span>&nbsp; -->
              <i class="fas fa-envelope"></i>
            </div>
            <div class="size2 pl-1">
              <span class="txt1 p-b-20">
                {{ $t("aboutus.email") + " " }}
              </span>
              <span class="txt3 pl-1">
                ited.faramiran@gmail.com
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="dropDownSelect1"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      agent_firstname: "",
      agent_lastname: "",
      agent_mobile_number: "",
      phone_number: "",
      province: "",
      description: "",
      brand: "",
      city: "",
      address: "",
      alert: false,
      errors: [],
    };
  },
  methods: {
    supplierRegister() {
      const supplier_data = {
        agent_firstname: this.agent_firstname,
        agent_lastname: this.agent_lastname,
        agent_mobile_number: this.agent_mobile_number,
        phone_number: this.phone_number,
        province: "تهران",
        description: this.description,
        brand: this.brand,
        city: "تهران",
        address: this.address,
      };
      this.$store
        .dispatch("supplierRegister", supplier_data)
        .then(() => this.$router.push("/supplier-success"))
        .catch((err) => {
          console.log(err);
          this.alert = true;
          this.errors = err.body;
        });
    },
  },
};
</script>
